/**
 * Render mixin form renderless forms
 * ```js
 * // You can extend scoped properties in a per form basis by creating a computed property called innerScope
 * export default {
 *   computed: {
 *     innerScope() {
 *       return {
 *         anotherProperty: this.anotherProperty
 *       }
 *     }
 *   }
 * }
 * ```
 */
export default {
  computed: {
    /**
     * @vuese
     * Expose properties for the default slot scope can be extended
     * default props: serverErrorMsg, isValid, isMounted, isLoading,
     */
    scope() {
      return {
        serverErrorMsg: this.serverErrorMsg,
        isValid: this.isValid,
        isMounted: this.isMounted,
        isLoading: this.isLoading,
        ...(this.innerScope || {})
      }
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}